<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>

<div class="dashboard-wrapper py-3 px-3">
  <div class="row m-0">
    <div
      class="col-md-4 col-sm-6 p-2"
      *ngFor="let item of dashboardData; let ind = index"
      (click)="getDetail(item.ShortName)"
    >
      <div class="dashboard-stat-card">
        <div class="stat-content">
          <div class="stat-info">
            <span class="stat-title">{{ item.IconName }}</span>
            <span class="stat-subtitle">View pending items</span>
          </div>
          <div class="stat-badge">
            {{ item.ItemCount }}
          </div>
        </div>
        <div class="stat-accent-bar"></div>
      </div>
    </div>
  </div>
</div>
